<app-menu-common url="hr"></app-menu-common>

@if (hrService.backendMissing()) {
	<div class="hr-backend-warn">Backend RH non déployé : données indisponibles (voir docs/backend-brief-hr.md).</div>
}

<div class="flexrow hr-header">
	<button mat-icon-button aria-label="Année précédente" (click)="onYearShift(-1)">
		<mat-icon>chevron_left</mat-icon>
	</button>
	<span class="year-label">{{ year }}</span>
	<button mat-icon-button aria-label="Année suivante" (click)="onYearShift(1)">
		<mat-icon>chevron_right</mat-icon>
	</button>

	<!-- LA VUE — ce qu'on est venu faire. Le compte fait partie du libellé : « À traiter (3) » est
	     autant une alerte qu'un filtre, et il se voit sans avoir à cliquer. -->
	<mat-button-toggle-group class="view-toggle" [formControl]="viewCtrl" aria-label="Vue">
		@for (v of views; track v.value) {
			<mat-button-toggle [value]="v.value" [matTooltip]="v.hint"
				[class.has-todo]="v.value === 'todo' && counts.todo > 0">
				{{ v.label }}
				<span class="view-count">{{ counts[v.value] }}</span>
			</mat-button-toggle>
		}
	</mat-button-toggle-group>

	<!-- REGROUPER — l'autre question. La liste détaillée répond à « que dois-je traiter » ;
	     groupée, elle répond à « qui s'absente, et quand », une personne par ligne. -->
	<mat-button-toggle class="group-toggle" id="leavegroupbutton" [checked]="grouped"
		(change)="groupCtrl.setValue($event.source.checked)"
		matTooltip="Une ligne par salarié : toute son année sur une seule réglette">
		<mat-icon>groups</mat-icon>&nbsp;Par salarié
	</mat-button-toggle>

	<span class="spacer"></span>
	<!-- « Ce matin, il n'est pas là » : le responsable note le fait avant d'en connaître ni la
	     durée ni la cause. Réservé aux habilités RH — ce n'est pas une demande, c'est un constat. -->
	@if (isAdmin) {
		<button mat-stroked-button id="constatbutton" (click)="onConstat()">
			<mat-icon>person_off</mat-icon>&nbsp;Absence constatée
		</button>
		&nbsp;
	}
	<!-- Le mot change avec celui qui clique : le salarié DEMANDE un congé, le responsable RH le
	     SAISIT — il décide en écrivant, il ne s'adresse pas une demande à lui-même. -->
	<button mat-flat-button color="primary" id="newleavebutton" (click)="onNew()">
		<mat-icon>event_available</mat-icon>&nbsp;{{ isAdmin ? 'Saisir une absence' : 'Nouvelle demande' }}
	</button>
</div>

<!-- LE PÉRIMÈTRE — de qui parle-t-on ? Inutile quand on ne voit que ses propres demandes : la
     barre entière est réservée aux habilités RH. -->
@if (isAdmin) {
	<div class="flexrow hr-filters">
		@if (stores.length > 1) {
			<mat-form-field class="scope-field">
				<mat-label>Établissement</mat-label>
				<mat-select [formControl]="storeCtrl" id="leavestorefilter">
					<mat-option [value]="null">Tous</mat-option>
					@for (s of stores; track s.id) {
						<mat-option [value]="s.id">{{ s.name }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
		}

		@if (teams.length > 0) {
			<mat-form-field class="scope-field">
				<mat-label>Équipe</mat-label>
				<mat-select [formControl]="teamCtrl" id="leaveteamfilter">
					<mat-option [value]="null">Toutes</mat-option>
					@for (t of teams; track t.id) {
						<mat-option [value]="t.id">{{ t.name }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
		}

		<!-- Les motifs se COCHENT : on veut « maladie + accident du travail », pas l'un ou l'autre.
		     Rien de coché = tous, ce qui évite l'état absurde d'une liste vide. -->
		<mat-form-field class="scope-field type-field">
			<mat-label>Motifs</mat-label>
			<mat-select [formControl]="typeCtrl" id="leavetypefilter" multiple placeholder="Tous">
				@for (t of typeChoices; track t.id) {
					<mat-option [value]="t.id">
						<span class="typ-dot" [style.background]="t.data?.color ?? '#9e9e9e'"></span>
						{{ t.name }}
					</mat-option>
				}
			</mat-select>
		</mat-form-field>

		<mat-form-field class="scope-field search-field">
			<mat-label>Rechercher</mat-label>
			<input matInput [formControl]="searchCtrl" id="leavesearch" placeholder="Nom, motif, commentaire…">
			<mat-icon matSuffix>search</mat-icon>
		</mat-form-field>

		@if (hasScopeFilter) {
			<button mat-icon-button matTooltip="Effacer les filtres" aria-label="Effacer les filtres" (click)="onResetFilters()" id="leaveresetfilters">
				<mat-icon>filter_alt_off</mat-icon>
			</button>
		}

		<span class="spacer"></span>
		<span class="result-summary">
			{{ dataSource.data.length }} absence{{ dataSource.data.length > 1 ? 's' : '' }}
			· {{ shownDays }} jour{{ shownDays > 1 ? 's' : '' }}
			@if (grouped) {
				· {{ groupSource.data.length }} salarié{{ groupSource.data.length > 1 ? 's' : '' }}
			}
		</span>
	</div>
}

<div class="pagecontent">
	<!-- CLÔTURE DE L'ANNÉE DE CONGÉS — le rappel de campagne.
	     L'écran des congés est celui qu'on ouvre pour poser des jours : c'est donc ici qu'il faut
	     dire « l'année s'achève, votre solde vous attend ». Deux publics, deux phrases. -->
	@if (closingWindow; as w) {
		@if (myClosingToAck) {
			<div class="closing-call ack">
				<mat-icon>how_to_reg</mat-icon>
				<div class="closing-body">
					<span class="closing-title">Votre solde de congés {{ leavePeriodShortLabel(w.period) }} vous attend</span>
					<span class="closing-detail">
						Le responsable a arrêté votre compte de l'année écoulée : vérifiez-le et validez-le.
					</span>
				</div>
				<a mat-flat-button color="primary" routerLink="/hr/leave-closing" id="leaveclosingcall">Voir mon solde</a>
			</div>
		} @else if (isAdmin && w.open && closingTodo > 0) {
			<div class="closing-call" [class.late]="w.late">
				<mat-icon>{{ w.late ? 'priority_high' : 'campaign' }}</mat-icon>
				<div class="closing-body">
					<span class="closing-title">
						{{ closingTodo }} compte{{ closingTodo > 1 ? 's' : '' }} de congés à arrêter — année {{ leavePeriodShortLabel(w.period) }}
					</span>
					<span class="closing-detail">
						@if (w.late) {
							La période est close et rien n'est reporté sur l'année en cours tant que les comptes ne sont pas arrêtés.
						} @else {
							L'année de congés s'achève : dites à chacun ce qu'il lui reste, et ce qu'on en fait.
						}
					</span>
				</div>
				<a mat-stroked-button routerLink="/hr/leave-closing" id="leaveclosinglink">Clôturer</a>
			</div>
		}
	}

	<!-- Mon stock d'heures supplémentaires mises en repos : il se pose comme un congé, alors il
	     s'affiche là où on pose ses congés. Masqué si l'établissement n'a pas de type
	     « récupération », ou si le compte connecté n'a pas de fiche salarié. -->
	@if (myRcrAccount; as account) {
		<div class="rcr-card" [class.empty]="account.available_min <= 0">
			<mat-icon>history_toggle_off</mat-icon>
			<div class="rcr-body">
				<span class="rcr-title">Mes heures à récupérer</span>
				<span class="rcr-detail">
					{{ rcrLabel(account.credited_min) }} acquis
					@if (account.taken_min > 0) { · {{ rcrLabel(account.taken_min) }} déjà pris }
					@if (account.pending_min > 0) { · {{ rcrLabel(account.pending_min) }} en attente de réponse }
				</span>
			</div>
			<span class="rcr-available" [matTooltip]="account.available_min > 0
				? (isAdmin ? 'Posez-les avec « Saisir une absence », type Récupération'
				           : 'Posez-les avec « Nouvelle demande », type Récupération')
				: 'Rien à récupérer pour l\'instant'">
				{{ rcrLabel(account.available_min) }}
			</span>
		</div>
	}

	@if (!grouped) {
		<!-- La colonne des actions vaut ses boutons, ni plus ni moins : le commentaire prend tout le
		     reste, jusqu'au bord du tableau. -->
		<table mat-table [dataSource]="dataSource" matSort #detailSort="matSort" class="mat-elevation-z2 leave-table"
			[style.--actions-w.px]="actionsWidth">
			<ng-container matColumnDef="employee">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Employé</th>
				<td mat-cell *matCellDef="let row">
					<span class="employee-name" [matTooltip]="row.employee">{{ row.employee }}</span>
					<!-- L'établissement sous le nom : sur quatre cents salariés, deux homonymes ne se
					     distinguent que par là — et le responsable multi-sites y lit son périmètre. -->
					@if (row.store) { <span class="employee-store">{{ row.store }}</span> }
				</td>
			</ng-container>
			<ng-container matColumnDef="typ">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
				<td mat-cell *matCellDef="let row">
					<span class="typ-chip" [style.--absence-color]="row.typColor">{{ row.typ }}</span>
				</td>
			</ng-container>

			<!-- PÉRIODE ÉCRITE — colonne à part, de largeur FIXE. Collée à la réglette, elle la
			     décalait d'une ligne à l'autre : « 25/05/2026 (1 j) » ne pousse pas comme
			     « 27/07/2026 → 01/08/2026 (6 j) », et deux segments du même mois ne tombaient plus
			     l'un sous l'autre — ce qui est pourtant tout l'intérêt d'une frise. -->
			<ng-container matColumnDef="period">
				<th mat-header-cell *matHeaderCellDef mat-sort-header="period"
					matTooltip="Trier par date de début">Période</th>
				<td mat-cell *matCellDef="let row" class="period-text">
					{{ row.period }} <span class="days">({{ row.days }} j)</span>
				</td>
			</ng-container>

			<!-- LA RÉGLETTE — sa propre colonne, donc la même largeur pour toutes les lignes ET pour
			     l'échelle des mois de l'en-tête, qui s'aligne enfin sur les segments. -->
			<ng-container matColumnDef="ribbon">
				<th mat-header-cell *matHeaderCellDef [attr.aria-label]="'Réglette de l\'année ' + year">
					<ng-container *ngTemplateOutlet="ribbonScale"></ng-container>
				</th>
				<td mat-cell *matCellDef="let row">
					<span class="ribbon" [style.background-image]="monthGrid" [style.--lanes]="1"
						[matTooltip]="row.typ + ' — ' + row.period + ' (' + row.days + ' j)'">
						<ng-container *ngTemplateOutlet="ribbonBars; context: { $implicit: row }"></ng-container>
					</span>
				</td>
			</ng-container>

			<ng-container matColumnDef="state">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>État</th>
				<td mat-cell *matCellDef="let row">
					<span class="state-chip state-{{ row.state }}">{{ row.stateLabel }}</span>
					@if (row.isOpen) {
						<span class="state-chip open"
							matTooltip="Fin inconnue : l'absence court jusqu'à sa clôture">en cours</span>
					}
				</td>
			</ng-container>
			<ng-container matColumnDef="comment">
				<th mat-header-cell *matHeaderCellDef>Commentaire</th>
				<!-- Tronqué à l'affichage, entier au survol : la moitié des commentaires sont des
				     « Prolongation prescrite le … » dont la fin porte l'information. -->
				<td mat-cell *matCellDef="let row" class="comment" [matTooltip]="row.comment"
					[matTooltipDisabled]="!row.comment">{{ row.comment }}</td>
			</ng-container>
			<ng-container matColumnDef="actions">
				<th mat-header-cell *matHeaderCellDef></th>
				<td mat-cell *matCellDef="let row" class="actions">
					@if (row.canDecide) {
						<button mat-icon-button color="primary" matTooltip="Approuver" aria-label="Approuver la demande" (click)="onApprove(row)">
							<mat-icon>check_circle</mat-icon>
						</button>
						<button mat-icon-button color="warn" matTooltip="Refuser" aria-label="Refuser la demande" (click)="onRefuse(row)">
							<mat-icon>cancel</mat-icon>
						</button>
					}
					@if (row.canRequalify) {
						<button mat-icon-button matTooltip="Requalifier (changer le type, la période…)" aria-label="Requalifier la demande" (click)="onRequalify(row)">
							<mat-icon>edit_note</mat-icon>
						</button>
					}
					<!-- Clôturer : donner la date de fin et, s'il y a lieu, la vraie nature de l'arrêt.
					     Le salarié le fait sur la sienne — c'est lui qui reçoit l'arrêt de travail. -->
					@if (row.canClose) {
						<button mat-icon-button color="primary" matTooltip="Clôturer : date de fin et nature de l'arrêt"
							aria-label="Clôturer l'arrêt" (click)="onRequalify(row)">
							<mat-icon>event_busy</mat-icon>
						</button>
					}
					@if (row.canCancel) {
						<button mat-icon-button matTooltip="Annuler la demande" aria-label="Annuler la demande" (click)="onCancel(row)">
							<mat-icon>undo</mat-icon>
						</button>
					}
				</td>
			</ng-container>

			<tr mat-header-row class="table_head" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
			<!-- La ligne EN ATTENTE se signale d'elle-même : elle est en tête, mais elle doit rester
			     reconnaissable après un tri par nom ou par date. -->
			<tr mat-row *matRowDef="let row; columns: displayedColumns;" [class.row-pending]="row.state === 0"></tr>
		</table>

		<!-- Une page à la fois : le DOM ne grossit plus avec l'effectif. -->
		<mat-paginator #detailPager [pageSizeOptions]="[25, 50, 100, 200]" [pageSize]="50" showFirstLastButtons
			aria-label="Page d'absences"></mat-paginator>
	} @else {
		<!-- ============================================================
		     MODE GROUPÉ — une personne, une ligne
		     ============================================================
		     Les périodes écrites n'y tiennent plus : un salarié en cumule parfois trente dans
		     l'année. Elles passent dans le panneau de survol, avec leur motif et leur état. -->
		<table mat-table [dataSource]="groupSource" matSort #groupSort="matSort" class="mat-elevation-z2 leave-table grouped">
			<ng-container matColumnDef="employee">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Employé</th>
				<td mat-cell *matCellDef="let row">
					<span class="employee-name" [matTooltip]="row.employee">{{ row.employee }}</span>
					@if (row.store) { <span class="employee-store">{{ row.store }}</span> }
				</td>
			</ng-container>

			<ng-container matColumnDef="summary">
				<th mat-header-cell *matHeaderCellDef mat-sort-header="summary"
					matTooltip="Trier par nombre de jours d'absence">Absences</th>
				<td mat-cell *matCellDef="let row" class="group-summary">
					<span class="group-count">
						{{ row.count }} absence{{ row.count > 1 ? 's' : '' }}
						· {{ row.days }} j
					</span>
					<!-- Une décision attend, et ce mode ne sait pas la prendre : le badge le dit et
					     renvoie à la liste détaillée, qui porte les boutons. -->
					@if (row.pending > 0) {
						<span class="group-pending"
							matTooltip="Repassez en liste détaillée pour approuver ou refuser">
							{{ row.pending }} en attente
						</span>
					}
				</td>
			</ng-container>

			<ng-container matColumnDef="ribbon">
				<th mat-header-cell *matHeaderCellDef [attr.aria-label]="'Réglette de l\'année ' + year">
					<ng-container *ngTemplateOutlet="ribbonScale"></ng-container>
				</th>
				<td mat-cell *matCellDef="let row">
					<span class="ribbon hoverable" [style.background-image]="monthGrid" [style.--lanes]="row.lanes"
						(mouseenter)="onGroupEnter($event, row)" (mouseleave)="onGroupLeave()">
						<ng-container *ngTemplateOutlet="ribbonBars; context: { $implicit: row }"></ng-container>
					</span>
				</td>
			</ng-container>

			<tr mat-header-row class="table_head" *matHeaderRowDef="groupedColumns; sticky: true"></tr>
			<tr mat-row *matRowDef="let row; columns: groupedColumns;" [class.row-pending]="row.pending > 0"></tr>
		</table>

		<mat-paginator #groupPager [pageSizeOptions]="[25, 50, 100, 200]" [pageSize]="50" showFirstLastButtons
			aria-label="Page de salariés"></mat-paginator>
	}

	@if (isEmpty) {
		<div class="hr-empty">
			@if (hasScopeFilter || viewCtrl.value !== 'all') {
				Aucune absence sur {{ year }} avec ces filtres.
				<button mat-button color="primary" (click)="onResetFilters(); viewCtrl.setValue('all')">Tout afficher</button>
			} @else {
				Aucune absence enregistrée sur {{ year }}.
			}
		</div>
	}
</div>

<!-- ============================================================
     Gabarits partagés par les deux modes
     ============================================================
     La géométrie des segments ne vit qu'ICI : dessinée deux fois, elle finirait par différer d'un
     mode à l'autre, et deux frises qui ne se ressemblent plus ne se comparent plus. -->

<!-- L'échelle des mois de l'en-tête — même colonne, même largeur, donc même alignement que les
     segments des lignes. Le trait d'aujourd'hui la traverse comme il traverse la liste. -->
<ng-template #ribbonScale>
	<span class="ribbon-scale" aria-hidden="true">
		@for (m of monthTicks; track $index) {
			<span class="scale-month" [style.left.%]="m.left" [style.width.%]="m.width">{{ m.label }}</span>
		}
		@if (todayPct !== null) { <span class="scale-today" [style.left.%]="todayPct"></span> }
	</span>
</ng-template>

<!-- Les barres d'une réglette : une seule en mode détaillé, autant que d'absences en mode groupé.
     `lane` est la couche d'empilement — deux périodes qui se chevauchent ne partagent pas la même
     bande, sinon la plus courte disparaîtrait sous la plus longue. -->
<ng-template #ribbonBars let-row>
	@for (s of row.segments; track s.id) {
		<span class="ribbon-bar state-{{ s.state }}"
			[class.open]="s.open"
			[class.clipped-start]="s.ribbon.clippedStart"
			[class.clipped-end]="s.ribbon.clippedEnd"
			[style.--absence-color]="s.color"
			[style.--lane]="s.lane"
			[style.left.%]="s.ribbon.left" [style.width.%]="s.ribbon.width"></span>
	}
	@if (todayPct !== null) { <span class="ribbon-today" [style.left.%]="todayPct"></span> }
</ng-template>

<!-- ============================================================
     PANNEAU DE SURVOL — la ligne groupée en toutes lettres
     ============================================================
     Une réglette dit QUAND, jamais QUOI : douze segments n'ont pas la place de porter leurs dates,
     leur motif et leur état. Le survol les rend, dans l'ordre où ils se posent sur la frise. -->
<ng-template #groupPanel>
	@if (hoverGroup; as g) {
		<div class="group-panel" (mouseenter)="onPanelEnter()" (mouseleave)="onGroupLeave()">
			<div class="group-panel-head">
				<span class="gp-name">{{ g.employee }}</span>
				<span class="gp-sub">
					{{ g.count }} absence{{ g.count > 1 ? 's' : '' }} · {{ g.days }} jour{{ g.days > 1 ? 's' : '' }}
					@if (g.store) { · {{ g.store }} }
				</span>
			</div>
			<div class="group-panel-list">
				@for (e of g.entries; track e.id) {
					<div class="gp-row">
						<span class="gp-period">{{ e.period }} <span class="days">({{ e.days }} j)</span></span>
						<span class="typ-chip" [style.--absence-color]="e.typColor">{{ e.typ }}</span>
						<span class="gp-state">
							<span class="state-chip state-{{ e.state }}">{{ e.stateLabel }}</span>
							@if (e.isOpen) { <span class="state-chip open">en cours</span> }
						</span>
					</div>
				}
			</div>
		</div>
	}
</ng-template>
